import ProxyBase from '../../../core/proxies/ProxyBase'

class ChatBoxProxy extends ProxyBase {
  getListTopic(params) {
    return this.get('Topic/GetTopicPaggingByModifiedDate', params)
  }

  getMessageInTopic(params) {
    return this.get('Message/Gets', params)
  }

  updateTopic(params) {
    return this.post('Topic/Update', params)
  }

  getQuestion(params) {
    return this.get('Question/GetByUserSetting', params)
  }

  getTopicMaxUpdatedDate(params) {
    return this.get('Topic/GetTopicMaxUpdatedDate', params)
  }
}

export default new ChatBoxProxy(
  '',
  `${process.env.REACT_APP_CHATBOT_CONNECT_URL}/api`,
)
